module.exports = __webpack_public_path__ + "img/Mover_Front.5346f445.svg";